import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer({ navigateToAnchor }) {
    const linkBtnClass = "footer-link bg-transparent border-0 p-0";
    const goAnchor = (e, anchor) => {
        e.preventDefault();
        if (navigateToAnchor) navigateToAnchor(anchor);
    };
    return (
        <footer className="site-footer mt-auto">
            <Container>
                <Row className="gy-4">
                    <Col lg={4} md={12} className="mb-3 mb-lg-0">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <img
                                src={`${process.env.PUBLIC_URL}/brand/referom-mark-192.png`}
                                srcSet={`${process.env.PUBLIC_URL}/brand/referom-mark-192.png 1x, ${process.env.PUBLIC_URL}/brand/referom-mark-512.png 2x`}
                                alt=""
                                aria-hidden="true"
                                className="brand-mark"
                            />
                            <span className="brand-name">Referom</span>
                        </div>
                        <p className="text-dim mb-3" style={{ fontSize: '0.875rem', maxWidth: '300px' }}>
                            Stop disinformation at the citation. Every reference checked, every quote traced, every score auditable.
                        </p>
                        <div className="d-flex gap-3" style={{ fontSize: '0.875rem' }}>
                            <a href="https://www.linkedin.com/in/aschwabe/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                            <a href="mailto:hello@referom.com">hello@referom.com</a>
                        </div>
                    </Col>
                    <Col lg={2} md={3} sm={6}>
                        <p className="footer-heading">Product</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'why')} className={linkBtnClass}>Why Referom</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'audiences')} className={linkBtnClass}>Who It&rsquo;s For</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'integration')} className={linkBtnClass}>Integration</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'how')} className={linkBtnClass}>How It Works</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'pillars')} className={linkBtnClass}>Pillars</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'scope')} className={linkBtnClass}>What We Don&rsquo;t Do</button>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={2} md={3} sm={6}>
                        <p className="footer-heading">Vision</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'vision')} className={linkBtnClass}>Phase 1 &amp; 2</button>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={2} md={3} sm={6}>
                        <p className="footer-heading">Company</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'founder')} className={linkBtnClass}>Founder</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={(e) => goAnchor(e, 'contact')} className={linkBtnClass}>Contact</button>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={2} md={3} sm={6}>
                        <p className="footer-heading">Contact</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <a href="mailto:hello@referom.com">hello@referom.com</a>
                            </li>
                            <li className="mb-2">
                                <a href="https://www.linkedin.com/in/aschwabe/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row className="mt-4 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    <Col className="text-center text-dim" style={{ fontSize: '0.8rem' }}>
                        &copy; {new Date().getFullYear()} Referom. All rights reserved.
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
